<template>
	
	<HistoryList v-if="$store.getters.client.id" class="twenty-padding scroll-y" :client_id="$store.getters.client.id"/>
	
</template>

<script>

	import HistoryList from "@/components/History/List";
	
	export default {
		
		components: { HistoryList },
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Clients/History.vue